import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import { Lists_loaikhoan, Lists_tinhchatnguonkp, Lists_tieumuc, Lists_nguonkinhphi } from '../../../routes/menu'
import 'jquery'
import 'bootstrap'


const swal = require('sweetalert');
@Component({
  selector: 'app-dm-taikhoanketchuyenedit',
  templateUrl: './taikhoanketchuyenedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./taikhoanketchuyenedit.component.scss'],
    providers: [ListService, Repository]
})


export class taikhoanketchuyeneditComponent implements OnInit {

   
    
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  inputparents: any
  indLoading: boolean = false;
  doituongSelect: any = {
    Id: null, Don_Vi_Id: null, Tai_Khoan_Den_Id: null, Tai_Khoan_Den: null
    , Tai_Khoan_Di_Id: null, Tai_Khoan_Di: null, Dien_Giai: null, Thu_Tu: null
    , Loai_Ket_Chuyen: null, Kieu_Ket_Chuyen: null, Trang_Thai: null, Nguon_Id: null, ThongTu: null
  };    
    nhomdtid:string=null;
  hoatdong: string = null;
  inputloaikhoans: any;
  inputtieumucs: any;
  inputtaikhoantaisans: any;
  inputnguons: any;
  public inputloaiketchuyens: Array<{ Id: number, Ma_Doi_Tuong: string, Ten_Doi_Tuong: string }> = [
    { Id: 0, Ma_Doi_Tuong: "Kết chuyển số dư cuối năm", Ten_Doi_Tuong: "Kết chuyển số dư cuối năm" },
    { Id: 1, Ma_Doi_Tuong: "Xác định kết quả hoạt động", Ten_Doi_Tuong: "Xác định kết quả hoạt động" },
    { Id: 2, Ma_Doi_Tuong: "Quyết toán số đầu năm", Ten_Doi_Tuong: "Quyết toán số đầu năm" },
  ];
  public inputkieuketchuyens: Array<{ Id: number, Ma_Doi_Tuong: string, Ten_Doi_Tuong: string }> = [
    { Id: 0, Ma_Doi_Tuong: "Kết chuyển bên nợ", Ten_Doi_Tuong: "Kết chuyển bên nợ" },
    { Id: 1, Ma_Doi_Tuong: "kết chuyển bên có", Ten_Doi_Tuong: "kết chuyển bên có" },
    { Id: 2, Ma_Doi_Tuong: "Kết chuyển hai bên", Ten_Doi_Tuong: "Kết chuyển hai bên" },
  ];


  @ViewChild('slLoaiKhoan', { static: false }) slLoaiKhoan: NgSelectComponent;
  @ViewChild('slTieuMuc', { static: false }) slTieuMuc: NgSelectComponent;
  @ViewChild('slTaiKhoanTaiSan', { static: false }) slTaiKhoanTaiSan: NgSelectComponent;
  @ViewChild('slTaiKhoanHaoMon', { static: false }) slTaiKhoanHaoMon: NgSelectComponent;
  @ViewChild('slCapTren', { static: false }) slCapTren: NgSelectComponent;
    @Output() save: EventEmitter<any> = new EventEmitter();
  
  public ngxCurrencyOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 0,
    allowNegative: false
  };


    constructor( private _dataService: ListService, private repo: Repository) {
       
        
    }

    ngOnInit(): void {
       
    }

    // @HostListener('document:keydown', ['$event'])
    // public handleKeyboardEvent(event: KeyboardEvent): void {
      
    //   if(event.key==="F9")
    //   {
    //       this.saveproduct();
    //   }
    //   event.stopPropagation();
     
    // }

    comboSearchFn(term: string, item: any) {
        term = term.toLowerCase();
        return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
    }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;
  nam: number;

  loadDataInit(nhomdoituongid: string, id: string, donviid: string) {

    this.repo.postRequest('api/taikhoan/dstaikhoanv2', { NamKeToan: 2024, DonViId: donviid, UserName: null })
      .subscribe(response => {this.inputtaikhoantaisans = response;  });

  
    //this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_loaikhoan.id, MaGiaoDien: '', DonViId: donviid})
    //  .subscribe(response => {
    //    this.inputloaikhoans = response;
    //  });
    //this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_tieumuc.id, MaGiaoDien: '', DonViId: donviid })
    //  .subscribe(response => {
    //    this.inputtieumucs = response;
    //  });


    if (nhomdoituongid.toLocaleLowerCase() === Lists_tinhchatnguonkp.id.toLocaleLowerCase())
      this.bnguonkinhphi = true;   
      this.hoatdong = "Hoạt động"

          var authlogin = localStorage.getItem('currentUser');
          if (authlogin) {

            let data = JSON.parse(authlogin);
            this.nam = data.nam_ke_toan;
            var giatri = data.ds_quyen.filter(name => name.id === nhomdoituongid.toLowerCase());
            if (giatri != null && giatri.length > 0) {
              if (giatri[0].them == true)
                this.quyen_them = true;
              else
                this.quyen_them = false;
              if (giatri[0].sua == true)
                this.quyen_sua = true;
              else
                this.quyen_sua = false;
              if (giatri[0].xoa == true)
                this.quyen_xoa = true;
              else
                this.quyen_xoa = false;
            }
            this.repo.getRequest("api/doituong/getall2/" + Lists_nguonkinhphi.id + '/null/' + data.id_don_vi)
              .subscribe(response => {
                this.inputnguons = response;
              });

  
          }    

        this.nhomdtid = nhomdoituongid;
        setTimeout(() => {
            this.mafocus.nativeElement.focus();  
    }, 500);
    //this.repo.getRequest("api/doituong/getall2/" + nhomdoituongid + '/' + (id != null ? id:'null') + '/' + donviid)
    //    .subscribe(response => {            
    //        this.inputparents=response;
    //    });
    this.doituongSelect = {
      Id: null, Don_Vi_Id: null, Tai_Khoan_Den_Id: null, Tai_Khoan_Den: null
      , Tai_Khoan_Di_Id: null, Tai_Khoan_Di: null, Dien_Giai: null, Thu_Tu: null
      , Loai_Ket_Chuyen: null, Kieu_Ket_Chuyen: null, Trang_Thai: null, Nguon_Id: null, ThongTu: null};   
        
        if(id === null)
        {
            console.log("vao loaddatainit" + id);
            this.repo.getRequest("api/doituong/SinhMaDoiTuong/" + nhomdoituongid + '/'+donviid)
            .subscribe(response => {  
                console.log(response);
                this.doituongSelect.Ma_Doi_Tuong = response;
            });
          this.doituongSelect.Trang_Thai = true;
          this.doituongSelect.Tu_Chu = false;
          this.doituongSelect.ThongTu = "107";
          if (this.nam >= 2025)
            this.doituongSelect.ThongTu = "24";
        }
        else {
          console.log("t11");
          this.repo.getRequest("api/dmketchuyen/getbyid/" + id)
            .subscribe(response => {  
                console.log(response);
              this.doituongSelect.Id = id;
              this.doituongSelect.Don_Vi_Id = response.Don_Vi_Id;
              this.doituongSelect.Tai_Khoan_Den_Id = response.Tai_Khoan_Den_Id;
              this.doituongSelect.Tai_Khoan_Den = response.Tai_Khoan_Den;
              this.doituongSelect.Tai_Khoan_Di_Id = response.Tai_Khoan_Di_Id;
              this.doituongSelect.Tai_Khoan_Di = response.Tai_Khoan_Di;
              this.doituongSelect.Dien_Giai = response.Dien_Giai;
              this.doituongSelect.Thu_Tu = response.Thu_Tu;
              this.doituongSelect.Loai_Ket_Chuyen = response.Loai_Ket_Chuyen;
              this.doituongSelect.Kieu_Ket_Chuyen = response.Kieu_Ket_Chuyen;
              this.doituongSelect.Trang_Thai = response.Trang_Thai;
              this.doituongSelect.Nguon_Id = response.Nguon_Id;
              this.doituongSelect.ThongTu = response.ThongTu;
              
            }); 
        }
        
       
    }
   
    keyTenPress(event: any) { 
        if (event.which === 13) {
          this.slLoaiKhoan.focus();
            event.preventDefault();
          }
  }
  keyLoaiKhoanPress(event: any) {
    if (event.which === 13) {
      this.slTieuMuc.focus();
      event.preventDefault();
    }
  }
  keyTKNguyenGiaPress(event: any) {
    if (event.which === 13) {
      this.slTaiKhoanHaoMon.focus();
      event.preventDefault();
    }
  }
  keyTKHaoMonPress(event: any) {
    if (event.which === 13) {
      this.slCapTren.focus();
      event.preventDefault();
    }
  }
  keyThoiGianPress(event: any) {
    if (event.which === 13) {
      this.slTaiKhoanTaiSan.focus();
      event.preventDefault();
    }
  }
    public closeModal(){
        this.save.emit(null);
    }
    public saveproduct() {
        if (this.doituongSelect.Ten_Doi_Tuong == null || this.doituongSelect.Ten_Doi_Tuong == "") {
            swal('Lỗi!', 'Vui lòng nhập tên đối tượng!.', 'error');
            return;
      }
      console.log(this.doituongSelect);
      this.repo.postRequest("api/doituongtaisan/addorupdate",this.doituongSelect)
            .subscribe(response => {  
                
              if (response != null && response.match('-')) {
                this.doituongSelect.Id = response;
                this.save.emit(this.doituongSelect);
              }
              else {
                swal('Lỗi!', response, 'error');
              }
            }); 
    }
   
    
   

   


}
